'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./HorizontalLoader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Loader pro načítání dat - horizontální, typicky pro dlouhé seznamy položek apod.
 */
var HorizontalLoader = function (_React$Component) {
    (0, _inherits3.default)(HorizontalLoader, _React$Component);

    function HorizontalLoader() {
        (0, _classCallCheck3.default)(this, HorizontalLoader);
        return (0, _possibleConstructorReturn3.default)(this, (HorizontalLoader.__proto__ || (0, _getPrototypeOf2.default)(HorizontalLoader)).apply(this, arguments));
    }

    (0, _createClass3.default)(HorizontalLoader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                hover = _props.hover,
                other = (0, _objectWithoutProperties3.default)(_props, ['className', 'hover']);


            var clsCont = (0, _classnames2.default)("loaderInf-container", className, {
                hover: hover
            });
            var cls = (0, _classnames2.default)("loaderInf");
            return _react2.default.createElement(
                'div',
                { className: clsCont },
                _react2.default.createElement('div', (0, _extends3.default)({ className: cls }, other))
            );
        }
    }]);
    return HorizontalLoader;
}(_react2.default.Component); // --


HorizontalLoader.propTypes = {
    hover: _react2.default.PropTypes.bool // pokud je true, jedná se o loader, který není jako standardní div, ale objeví se NAD ostatními elementami, napřo pro využití v seznamech apod
};
exports.default = HorizontalLoader;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbG9hZGVyL0hvcml6b250YWxMb2FkZXIuanN4Il0sIm5hbWVzIjpbIkhvcml6b250YWxMb2FkZXIiLCJwcm9wcyIsImNsYXNzTmFtZSIsImhvdmVyIiwib3RoZXIiLCJjbHNDb250IiwiY2xzIiwiUmVhY3QiLCJDb21wb25lbnQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBRUE7OztJQUdxQkEsZ0I7Ozs7Ozs7Ozs7aUNBTVI7QUFBQSx5QkFDZ0MsS0FBS0MsS0FEckM7QUFBQSxnQkFDRUMsU0FERixVQUNFQSxTQURGO0FBQUEsZ0JBQ2FDLEtBRGIsVUFDYUEsS0FEYjtBQUFBLGdCQUN1QkMsS0FEdkI7OztBQUdMLGdCQUFNQyxVQUFVLDBCQUNaLHFCQURZLEVBRVpILFNBRlksRUFFRDtBQUNQQztBQURPLGFBRkMsQ0FBaEI7QUFNQSxnQkFBTUcsTUFBTSwwQkFDUixXQURRLENBQVo7QUFHQSxtQkFDSTtBQUFBO0FBQUEsa0JBQUssV0FBV0QsT0FBaEI7QUFDSSw4RUFBSyxXQUFXQyxHQUFoQixJQUF5QkYsS0FBekI7QUFESixhQURKO0FBTUg7OztFQXhCeUNHLGdCQUFNQyxTLEdBUnBEOzs7QUFRcUJSLGdCLENBRVZTLFMsR0FBWTtBQUNmTixXQUFPSSxnQkFBTUcsU0FBTixDQUFnQkMsSUFEUixDQUNZO0FBRFosQztrQkFGRlgsZ0I7QUEwQnBCIiwiZmlsZSI6Ikhvcml6b250YWxMb2FkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyAtLVxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjbGFzc05hbWVzIGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0ICcuL0hvcml6b250YWxMb2FkZXIuc2Nzcyc7XG5cbi8qKlxuICogTG9hZGVyIHBybyBuYcSNw610w6Fuw60gZGF0IC0gaG9yaXpvbnTDoWxuw60sIHR5cGlja3kgcHJvIGRsb3Vow6kgc2V6bmFteSBwb2xvxb5layBhcG9kLlxuICovXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBIb3Jpem9udGFsTG9hZGVyIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcblxuICAgIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgICAgIGhvdmVyOiBSZWFjdC5Qcm9wVHlwZXMuYm9vbC8vIHBva3VkIGplIHRydWUsIGplZG7DoSBzZSBvIGxvYWRlciwga3RlcsO9IG5lbsOtIGpha28gc3RhbmRhcmRuw60gZGl2LCBhbGUgb2JqZXbDrSBzZSBOQUQgb3N0YXRuw61taSBlbGVtZW50YW1pLCBuYXDFmW8gcHJvIHZ5dcW+aXTDrSB2IHNlem5hbWVjaCBhcG9kXG4gICAgfTtcblxuICAgIHJlbmRlcigpIHtcbiAgICAgICAgY29uc3Qge2NsYXNzTmFtZSwgaG92ZXIsIC4uLm90aGVyfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgY29uc3QgY2xzQ29udCA9IGNsYXNzTmFtZXMoXG4gICAgICAgICAgICBcImxvYWRlckluZi1jb250YWluZXJcIixcbiAgICAgICAgICAgIGNsYXNzTmFtZSwge1xuICAgICAgICAgICAgICAgIGhvdmVyXG4gICAgICAgICAgICB9XG4gICAgICAgICk7XG4gICAgICAgIGNvbnN0IGNscyA9IGNsYXNzTmFtZXMoXG4gICAgICAgICAgICBcImxvYWRlckluZlwiLFxuICAgICAgICApO1xuICAgICAgICByZXR1cm4gKFxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9e2Nsc0NvbnR9PlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPXtjbHN9IHsuLi5vdGhlcn0+XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgKTtcbiAgICB9XG5cbn07XG4iXX0=